import { useNavigate } from 'react-router-dom';

import Congratulations from 'assets/images/congratulations.png';
import Firecracker from 'assets/images/firecracker.png';

export default function TutorialDialog() {
  const navigate = useNavigate();

  const currentStep = 1;

  return (
    <div
      style={{
        boxShadow: '0px 10px 0px rgba(0, 0, 0, 0.3)',
      }}
      className="absolute left-1/2 top-1/2 z-20 w-[80%] max-w-[400px] -translate-x-1/2 -translate-y-1/2 rounded-3xl bg-white pb-[35px]"
    >
      <div className="relative mt-[18px]">
        <img src={Congratulations} className="scale-x-120" />
        <span
          style={{ textShadow: '0px 2px 0px rgba(0, 0, 0, 0.3)' }}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[20px] font-black uppercase text-[#FEF3A0]"
        >
          Congratulations
        </span>
      </div>
      <div className="relative -translate-y-[10px] text-center text-[16px] leading-[28px] text-[#391930]">
        <img src={Firecracker} className="w-full" />
        <span className="absolute bottom-0 left-1/2 w-full -translate-x-1/2 -translate-y-1/2 font-[800]">
          {'You purchased land!'}
          <br />
          {currentStep % 3 === 1 ? 'Want' : 'Ready'} to claim your bonus?
        </span>
      </div>

      <div className="flex items-center justify-center gap-[18px] text-white">
        <div>
          <button
            className="rounded-xl border-b-2 border-[#B9B9B9] bg-[#B9B9B9] font-bold"
            style={{ textShadow: '0px 2px 0px rgba(0, 0, 0, 0.3)' }}
          >
            <div className="rounded-xl border-2 border-[#292929] px-[16px] text-[24px] font-bold">CLOSE</div>
          </button>
        </div>
        <button
          onClick={() => navigate('/earn-more-points')}
          className="rounded-xl border-b-2 border-[#B9B9B9] bg-[#FF4F95] font-bold"
          style={{ textShadow: '0px 2px 0px rgba(0, 0, 0, 0.3)' }}
        >
          <div className="rounded-xl border-2 border-[#292929] px-[16px] text-[24px] font-bold">EARNED</div>
        </button>
      </div>
    </div>
  );
}
